import {AuthenticationStore} from "./authenticationStore.js";
import {authApi} from "../api/auth.js";
import {TaxAuthOnboardingStore} from "./taxAuthOnboardingStore.js";
import {taxAuthApi} from "../api/taxAuth.js";
import {TaxAuthBillingStore} from "./taxAuthBillingStore.js";
import {TaxCertOrderStore} from "./taxCertOrderStore.js";
import {webOrderEstimateApi} from "../api/webOrderEstimate.js";
import {orderPaymentApi} from "../api/orderPayment.js";
import { taxAuthOrderApi } from "../api/taxAuthOrder.js";

class RootStore {
    constructor() {
        this.authenticationStore = new AuthenticationStore(authApi);
        this.taxAuthOnboardingStore = new TaxAuthOnboardingStore(taxAuthApi);
        this.taxAuthBillingStore = new TaxAuthBillingStore()
        this.taxCertOrderStore = new TaxCertOrderStore(webOrderEstimateApi, taxAuthApi, orderPaymentApi, taxAuthOrderApi);
    }
}

const rootStore = new RootStore();
export default rootStore;
